import type { ReactNode } from "react";

import { BaseButton, type BaseButtonProps } from "../base-button";
import { FilterIcon } from "../icons";
import {
  createButtonStylesWaterfall,
  useButtonStylesWaterfall,
} from "../styles";

const buttonStyles = createButtonStylesWaterfall({
  idle: {
    common: {
      border: "none",
      cursor: "pointer",
      background: "transparent",
      padding: 0,
    },
  },
});

type FilterButtonProps = {
  icon?: ReactNode;
  badge?: boolean;
} & Pick<
  BaseButtonProps,
  "disabled" | "onPress" | "triggerRef" | "triggerProps" | "styles"
>;

export const FilterButton = ({ icon, ...baseProps }: FilterButtonProps) => {
  const { waterfall } = useButtonStylesWaterfall(buttonStyles);

  return (
    <BaseButton type="button" waterfall={waterfall} {...baseProps}>
      {icon}
    </BaseButton>
  );
};

FilterButton.Outlined = (
  props: Omit<FilterButtonProps, "icon"> & {
    dropdownState?: boolean;
  },
) => {
  return (
    <FilterButton
      {...props}
      icon={<FilterIcon badge={props.badge} variant="outlined" />}
    />
  );
};
FilterButton.Filled = (
  props: Omit<FilterButtonProps, "icon"> & {
    dropdownState?: boolean;
  },
) => {
  return (
    <FilterButton
      {...props}
      icon={<FilterIcon badge={props.badge} variant="filled" />}
    />
  );
};
